<template>
  <v-app-bar clipped-left app color="blue darken-3" dark :height="'56'">
    <v-app-bar-nav-icon
      @click.stop="toggleNavMenu"
      v-if="$vuetify.breakpoint.smAndDown"
    >
      <v-icon>{{ navMenuOpen ? "mdi-close" : "mdi-menu" }}</v-icon>
    </v-app-bar-nav-icon>
    <v-toolbar-title class="ml-0 mr-12 pl-4">
      <span class="main-logo">daba</span>
    </v-toolbar-title>

    <main-search></main-search>

    <v-spacer />

    <!-- <v-menu
      bottom
      offset-y
      v-model="showSoftphone"
      max-width="350"
      min-width="350"
      :close-on-content-click="isFalse"
    >
      <template v-slot:activator="{ on: menu }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn
              rounded
              elevation="0"
              :color="callStatusReady ? 'green' : 'secondary'"
              v-on="{ ...tooltip, ...menu }"
            >
              <v-icon left>mdi-phone</v-icon>
              {{ callStatusReady ? "Ready" : "Not Ready" }}
            </v-btn>
          </template>
          <span>Phone Controls</span>
        </v-tooltip>
      </template>
      <softphone ref="softphone"></softphone>
    </v-menu> -->

    <v-menu
      bottom
      offset-y
      v-model="showNotifications"
      max-width="35%"
      min-width="350"
    >
      <template v-slot:activator="{ on: menu }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn icon large v-on="{ ...tooltip, ...menu }">
              <v-badge
                :content="notificationCount"
                :value="notificationCount"
                color="error"
                overlap
              >
                <v-icon>mdi-bell</v-icon>
              </v-badge>
            </v-btn>
          </template>
          <span>Notifications</span>
        </v-tooltip>
      </template>
      <notifications ref="notifications"></notifications>
    </v-menu>

    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn icon large @click="onAddCustomer" v-on="on">
          <v-icon>mdi-account-plus</v-icon>
        </v-btn>
      </template>
      <span>New Customer</span>
    </v-tooltip>
  </v-app-bar>
</template>

<script>
const Notifications = () =>
  import(
    /* webpackChunkName: "components-global-Notifications" */ `./Notifications.vue`
  );
const MainSearch = () =>
  import(
    /* webpackChunkName: "components-global-MainSearch" */ `./MainSearch.vue`
  );
// const Softphone = () =>
//   import(
//     /* webpackChunkName: "components-global-Softphone" */ `./Softphone.vue`
//   );

export default {
  name: "TopNavigation",
  components: {
    Notifications,
    MainSearch
    // Softphone
  },
  data() {
    return {
      isFalse: false,
      // showSoftphone: false,
      showNotifications: false
    };
  },
  async created() {},
  computed: {
    userId() {
      return this.$store.getters["entities/settings/query"]().first().userId;
    },
    user() {
      return this.$store.getters["entities/users/find"](this.userId);
    },
    settings() {
      return this.$store.getters["entities/settings/query"]().first();
    },
    // telephony() {
    //   return this.$store.getters["entities/telephony/query"]().first();
    // },
    // callStatusReady() {
    //   const telephony = this.telephony;
    //   return telephony && telephony.status ? true : false;
    // },
    notificationCount() {
      return this.settings
        ? this.settings.callIsUnreadCount +
            this.settings.messageIsUnreadCount +
            this.settings.messageHaveNotRespondedCount +
            this.settings.chatIsUnreadCount +
            this.settings.chatHaveNotRespondedCount
        : 0;
    },
    navMenuOpen() {
      return this.$root.$children[0].navMenuOpen;
    }
  },
  methods: {
    toggleNavMenu() {
      this.$root.$children[0].navMenuOpen = !this.$root.$children[0].navMenuOpen;
    },
    onAddCustomer() {
      let vueThis = this;
      this.$root.$children[0].showCustomerEditorModals = true;
      let timer = setTimeout(function checkCustomerEditorModals() {
        vueThis.$root.$children[0].showCustomerEditorModals = true;
        if (
          vueThis.$root.$children[0].$refs["customer-editor-modals"] !=
          undefined
        ) {
          let theContainer =
            vueThis.$root.$children[0].$refs["customer-editor-modals"];
          theContainer.CustomerId = -1;
          theContainer.showCustomerDetailFormModal = true;
          timer = null;
        } else {
          setTimeout(vueThis.onAddCustomer, 100);
        }
      }, 100);
    }
  },
  watch: {}
};
</script>

<style lang="stylus" scoped>
.main-logo {
  font-weight: 700;
}
</style>
